
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ThemeProvider } from './config/LightDarkMode/ThemeContext';
import Background from './config/LightDarkMode/Background';
import Toggle from './config/LightDarkMode/ThemeToggle';
import React from 'react';


ReactDOM.render(
  <React.StrictMode>
        <ThemeProvider>
      <Background>
         <div className="absolute right-0 top-0 mr-4 mt-4 md:mr-6 md:mt-6">
            <Toggle />
          </div>
       
        <App />
          </Background>
    </ThemeProvider>,
  </React.StrictMode>,
  document.getElementById('root')
);